<template>
  <div>
    <b-table striped hover :items="orderList" :fields="fields">
      <template #cell(price)="data">
        ${{ data.item.price }}
      </template>
    </b-table>
    <b-alert variant="dark" show>
      There {{ verb }} {{ itemCount }} {{ noun }}, the total amount is ${{ amount }}.
    </b-alert>
    <p v-show="!paid" id="paypal-button-container" class="paypal-center"></p>
    <p v-show="paid" id="confirmation">{{ orderComplete }}</p>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
import { mapState, mapGetters } from "vuex";
import { postMemberCourses } from "@/api/home";
import { ensureUserInitialized } from "@/utils/user";
import { Auth } from "aws-amplify";
/** PayPal的注册客户ID */
const CLIENT_ID = process.env.VUE_APP_PAYPAL_ID;
/** 支付货币 */
const CURRENCY = process.env.VUE_APP_PAYPAL_CURRENCY;

export default {
  name: "PayPalCheckout",
  data() {
    return {
      fields: [
        { key: 'courseName', label: process.env.VUE_APP_CART_COURSE },
        { key: 'price', label: process.env.VUE_APP_CART_PRICE },
        { key: 'language', label: process.env.VUE_APP_CART_LANGUAGE },
      ],
      paid: false
    };
  },
  computed: {
    ...mapState('cart', ['orderList']),
    ...mapGetters('cart', ['amount']),
    orderComplete() {
      return process.env.VUE_APP_ORDER_COMPLETE || '';
    },
    itemCount() {
      return this.orderList.length;
    },
    verb() {
      return this.itemCount === 1 ? 'is' : 'are';
    },
    noun() {
      return this.itemCount === 1 ? 'course' : 'courses';
    }
  },
  mounted() {
    loadScript({
      'client-id': CLIENT_ID,
      currency: CURRENCY,
    }).then((paypal) => {
      paypal.Buttons({
        createOrder: (data, actions) => this.createOrder(data, actions),
        onApprove: (data, actions) => this.handleApprove(data, actions),
        onError: (err) => this.handleError(err),
      }).render("#paypal-button-container");
    });
  },
  methods: {
    async validateToken() {
      try {
        await Auth.currentSession(); // Access Token 或 Refresh Token 自动更新
        return true;
      } catch (error) {
        console.warn("Token 无效或已过期", error);
        await this.$bvModal.msgBoxOk(
          "ログインの有効期限が切れています。お支払いの前に再度ログインしてください。",
          {
            title: "認証失敗",
            okTitle: "ログインへ進む",
            centered: true,
            size: "sm",
          }
        );
        setTimeout(() => {
          this.$router.replace("/auth");
        }, 100);
        return false;
      }
    },
    async createOrder(data, actions) {
      const valid = await this.validateToken();
      if (!valid) {
        throw new Error("会话已失效，无法继续支付");
      }
      return actions.order.create({
        purchase_units: [{
          amount: { value: this.amount },
        }],
      });
    },
    async handleApprove(data, actions) {
      try {
        const capture = await actions.order.capture();
        this.paid = true;
        await ensureUserInitialized(); // ✅ 保证写入数据库
        await this.postMemberCourses(capture.id);

        // ✅ 向父组件发送事件，通知支付完成
        this.$emit("payment-complete");
      } catch (error) {
        console.error("注文処理に失敗しました:", error);
      }
    },
    handleError(error) {
      console.error("支払いに失敗しました:", error);
    },
    async postMemberCourses(orderId) {
      try {
        await postMemberCourses(this.orderList, orderId);
      } catch (error) {
        console.error("コース登録は失敗しました:", error);
      }
    },
  },
};
</script>

<style scoped>
#paypal-button-container {
  margin: 30px 0;
}
#confirmation {
  color: green;
  margin-top: 1em;
  font-size: 2em;
  text-align: center;
}
.paypal-center {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
#paypal-button-container > div {
  width: 100%;
  max-width: 680px;
}
</style>
